import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import Russian translations (base language)
import commonRu from './locales/ru/common.json';
import navigationRu from './locales/ru/navigation.json';
import authRu from './locales/ru/auth.json';
import shopRu from './locales/ru/shop.json';
import adminRu from './locales/ru/admin.json';
import adminShopRu from './locales/ru/admin-shop.json';
import adminUsersRu from './locales/ru/admin-users.json';
import adminPromoRu from './locales/ru/admin-promo.json';
import supportRu from './locales/ru/support.json';
import ratingRu from './locales/ru/rating.json';
import warehouseRu from './locales/ru/warehouse.json';
import wikiRu from './locales/ru/wiki.json';
import paymentRu from './locales/ru/payment.json';
import rouletteRu from './locales/ru/roulette.json';
import referralRu from './locales/ru/referral.json';
import accountsRu from './locales/ru/accounts.json';
import settingsRu from './locales/ru/settings.json';
import charactersRu from './locales/ru/characters.json';
import promoRu from './locales/ru/promo.json';
import termsRu from './locales/ru/terms.json';
import privacyRu from './locales/ru/privacy.json';
import rulesRu from './locales/ru/rules.json';
import homeRu from './locales/ru/home.json';
import downloadsRu from './locales/ru/downloads.json';
import testersRu from './locales/ru/testers.json';
import cartRu from './locales/ru/cart.json';
import pollRu from './locales/ru/poll.json';
import guideRu from './locales/ru/guide.json';
import postsRu from './locales/ru/posts.json';
import qaRu from './locales/ru/qa.json';
import gameDataRu from './locales/ru/game-data.json';

// Import English translations
import commonEn from './locales/en/common.json';
import navigationEn from './locales/en/navigation.json';
import authEn from './locales/en/auth.json';
import shopEn from './locales/en/shop.json';
import adminEn from './locales/en/admin.json';
import adminShopEn from './locales/en/admin-shop.json';
import adminUsersEn from './locales/en/admin-users.json';
import adminPromoEn from './locales/en/admin-promo.json';
import supportEn from './locales/en/support.json';
import ratingEn from './locales/en/rating.json';
import warehouseEn from './locales/en/warehouse.json';
import wikiEn from './locales/en/wiki.json';
import paymentEn from './locales/en/payment.json';
import rouletteEn from './locales/en/roulette.json';
import referralEn from './locales/en/referral.json';
import accountsEn from './locales/en/accounts.json';
import settingsEn from './locales/en/settings.json';
import charactersEn from './locales/en/characters.json';
import promoEn from './locales/en/promo.json';
import termsEn from './locales/en/terms.json';
import privacyEn from './locales/en/privacy.json';
import rulesEn from './locales/en/rules.json';
import homeEn from './locales/en/home.json';
import downloadsEn from './locales/en/downloads.json';
import testersEn from './locales/en/testers.json';
import cartEn from './locales/en/cart.json';
import pollEn from './locales/en/poll.json';
import guideEn from './locales/en/guide.json';
import postsEn from './locales/en/posts.json';
import qaEn from './locales/en/qa.json';
import gameDataEn from './locales/en/game-data.json';

// Import Ukrainian translations
import commonUk from './locales/uk/common.json';
import navigationUk from './locales/uk/navigation.json';
import authUk from './locales/uk/auth.json';
import shopUk from './locales/uk/shop.json';
import adminUk from './locales/uk/admin.json';
import adminShopUk from './locales/uk/admin-shop.json';
import adminUsersUk from './locales/uk/admin-users.json';
import adminPromoUk from './locales/uk/admin-promo.json';
import supportUk from './locales/uk/support.json';
import ratingUk from './locales/uk/rating.json';
import warehouseUk from './locales/uk/warehouse.json';
import wikiUk from './locales/uk/wiki.json';
import paymentUk from './locales/uk/payment.json';
import rouletteUk from './locales/uk/roulette.json';
import referralUk from './locales/uk/referral.json';
import accountsUk from './locales/uk/accounts.json';
import settingsUk from './locales/uk/settings.json';
import charactersUk from './locales/uk/characters.json';
import promoUk from './locales/uk/promo.json';
import termsUk from './locales/uk/terms.json';
import privacyUk from './locales/uk/privacy.json';
import rulesUk from './locales/uk/rules.json';
import homeUk from './locales/uk/home.json';
import downloadsUk from './locales/uk/downloads.json';
import testersUk from './locales/uk/testers.json';
import cartUk from './locales/uk/cart.json';
import pollUk from './locales/uk/poll.json';
import guideUk from './locales/uk/guide.json';
import postsUk from './locales/uk/posts.json';
import qaUk from './locales/uk/qa.json';
import gameDataUk from './locales/uk/game-data.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        common: commonRu,
        navigation: navigationRu,
        auth: authRu,
        shop: shopRu,
        admin: adminRu,
        'admin-shop': adminShopRu,
        'admin-users': adminUsersRu,
        'admin-promo': adminPromoRu,
        support: supportRu,
        rating: ratingRu,
        warehouse: warehouseRu,
        wiki: wikiRu,
        payment: paymentRu,
        roulette: rouletteRu,
        referral: referralRu,
        accounts: accountsRu,
        settings: settingsRu,
        characters: charactersRu,
        promo: promoRu,
        terms: termsRu,
        privacy: privacyRu,
        rules: rulesRu,
        home: homeRu,
        downloads: downloadsRu,
        testers: testersRu,
        cart: cartRu,
        poll: pollRu,
        guide: guideRu,
        posts: postsRu,
        qa: qaRu,
        gameData: gameDataRu,
      },
      en: {
        common: commonEn,
        navigation: navigationEn,
        auth: authEn,
        shop: shopEn,
        admin: adminEn,
        'admin-shop': adminShopEn,
        'admin-users': adminUsersEn,
        'admin-promo': adminPromoEn,
        support: supportEn,
        rating: ratingEn,
        warehouse: warehouseEn,
        wiki: wikiEn,
        payment: paymentEn,
        roulette: rouletteEn,
        referral: referralEn,
        accounts: accountsEn,
        settings: settingsEn,
        characters: charactersEn,
        promo: promoEn,
        terms: termsEn,
        privacy: privacyEn,
        rules: rulesEn,
        home: homeEn,
        downloads: downloadsEn,
        testers: testersEn,
        cart: cartEn,
        poll: pollEn,
        guide: guideEn,
        posts: postsEn,
        qa: qaEn,
        gameData: gameDataEn,
      },
      uk: {
        common: commonUk,
        navigation: navigationUk,
        auth: authUk,
        shop: shopUk,
        admin: adminUk,
        'admin-shop': adminShopUk,
        'admin-users': adminUsersUk,
        'admin-promo': adminPromoUk,
        support: supportUk,
        rating: ratingUk,
        warehouse: warehouseUk,
        wiki: wikiUk,
        payment: paymentUk,
        roulette: rouletteUk,
        referral: referralUk,
        accounts: accountsUk,
        settings: settingsUk,
        characters: charactersUk,
        promo: promoUk,
        terms: termsUk,
        privacy: privacyUk,
        rules: rulesUk,
        home: homeUk,
        downloads: downloadsUk,
        testers: testersUk,
        cart: cartUk,
        poll: pollUk,
        guide: guideUk,
        posts: postsUk,
        qa: qaUk,
        gameData: gameDataUk,
      },
    },
    fallbackLng: 'ru', // Russian as base language
    defaultNS: 'common',
    ns: [
      'common',
      'navigation',
      'auth',
      'shop',
      'admin',
      'admin-shop',
      'admin-users',
      'admin-promo',
      'support',
      'rating',
      'warehouse',
      'wiki',
      'payment',
      'roulette',
      'referral',
      'accounts',
      'settings',
      'characters',
      'promo',
      'terms',
      'privacy',
      'rules',
      'home',
      'downloads',
      'testers',
      'cart',
      'poll',
      'guide',
      'posts',
      'qa',
      'gameData',
    ],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'locale',
    },
    // Pluralization rules for complex languages
    compatibilityJSON: 'v4', // Use v4 format for better pluralization support
  });

export default i18n;